import { defineColumn, type StrictColumnDef } from '../../../../components/tanstack-table/column';
import { totalCost } from '../../../../data/order-item';
import { preciseCurrencyFormatter } from '../../../../helpers/format-currency';
import type { ProductOrderItem } from '../data/product-order-item';

export const extendedCostColumn: StrictColumnDef<ProductOrderItem> = defineColumn<ProductOrderItem>(
  {
    id: 'Extended Cost',
    minWidth: 80,
    accessorFn: (orderItem) => preciseCurrencyFormatter(totalCost(orderItem)),
    toCSV: (orderItem) => ({
      'Extended Cost': totalCost(orderItem).toFixed(2),
    }),
  }
);
